'use strict';

wbApp.controller('ReferenceSourceCtrl', ['$scope', '$modal', 'referenceSourceSvc',
function ($scope, $modal, referenceSourceSvc) {

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.gridOptions = {
        sortInfo: { fields: ['name'], directions: ['dsc'] },
        columnDefs: [{ field: 'name', displayName: "TXT_LBL_NAME", sort: 'locale' }]
    };

    $scope.rederenceSource = referenceSourceSvc.getAllAsync(true);

    $scope.referenceSourceDetail = { name: '' };
    $scope.referenceSourceDetailOrig;

    $scope.onRowEdit = function (data) {
        $scope.referenceSourceDetail.id = data.id;
        $scope.referenceSourceDetail.name = data.name;
        $scope.referenceSourceDetail.isNew = false;

        $scope.referenceSourceDetailOrig = angular.copy($scope.referenceSourceDetail);

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            detailDialogPromise.show();
        });
    }

    $scope.detailError = null;

    $scope.onRowAdd = function () {
        $scope.referenceSourceDetail.id = -1;
        $scope.referenceSourceDetail.name = "";
        $scope.referenceSourceDetail.isNew = true;

        $scope.referenceSourceDetailOrig = angular.copy($scope.referenceSourceDetail);

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        referenceSourceSvc.remove(data);
    }

    $scope.onReferenceSourceDetailSave = function (data) {
        if (data.isNew) {
            referenceSourceSvc.insert(data, function (successResult) {
                detailDialogPromise.hide();
            }, function (errorResult) {
                $scope.detailError = errorResult;
            });
        } else {
            referenceSourceSvc.update(data, function (successResult) {
                detailDialogPromise.hide();
            }, function (errorResult) {
                $scope.detailError = errorResult;
            });
        }
    }

    $scope.tabs = [
    {
        title: 'TXT_REFERENCE_SOURCE_TIME_DEVELOPMENT',
        template: "users/reference-source-tabs/time-development.html"
    }];

    $scope.tabs.activeTab = 0;

    //$scope.$watch('tabs.activeTab', function (newValue, oldValue) {
    //    $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    //});

    var detailDialogPromise = $modal({
        templateUrl: 'users/reference-source-detail.html',
        show: false,
        scope: $scope
    });
}]);